var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecentlyLaunched = function SvgRecentlyLaunched(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 94 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M38 67.56h22.5c3 0 5.214-1.938 6-4.5l4.5-15c1.5-6-1.5-9-6-9H53s6-16.5-3-16.5l-12 16.5M38 37.56H24.5v30H38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M85.982 69.06C78.2 82.512 63.656 91.56 47 91.56c-24.852 0-45-20.148-45-45a44.8 44.8 0 0 1 6-22.464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 24.096C15.776 10.626 30.332 1.56 47 1.56c24.852 0 45 20.148 45 45 0 8.196-2.19 15.882-6.018 22.5"
  })));
};
export default SvgRecentlyLaunched;